// extracted by mini-css-extract-plugin
export default {"monitorTitle":"exam-dashboard_monitorTitle__KGp4k","monitorLabel":"exam-dashboard_monitorLabel__TwnU-","monitorItem":"exam-dashboard_monitorItem__7jSw0"};